export default {
  queryArticlesByPlatformId: '/gateway/cms/faq/queryArticlesByPlatformId',
  citySwitch: '/v3/cs/mileageCourier/citySwitch'
}
